import { useParams } from 'react-router';
import { useAdminContext } from '../AdminContext';
import { CatalogProductForm } from './CatalogProductForm';
import { useCatalogProductQuery } from './useCatalogProductEditor';
import { defaultCatalogProductForm, catalogProductToForm } from './catalogFormValues';
import { CatalogEntityHeader } from './CatalogEntityHeader';
import { CatalogRequestState } from './CatalogRequestState';
import './catalogEditor.css';

export function CatalogProductEditorPage() {
  const params = useParams();
  const { dictionaries } = useAdminContext();
  const routeId = params.productId;
  const entityId = routeId === undefined ? undefined : Number(routeId);
  const isValidId = entityId === undefined || (Number.isSafeInteger(entityId) && entityId > 0);
  const query = useCatalogProductQuery(isValidId ? entityId : undefined);
  const initialValues = routeId === undefined ? defaultCatalogProductForm(dictionaries) : query.data ? catalogProductToForm(query.data) : undefined;
  const errorMessage = !isValidId ? 'Некорректный адрес страницы.' : query.error?.message;

  return (
    <section className="admin-page catalog-workspace">
      {initialValues && !errorMessage ? (
        <CatalogProductForm key={routeId ?? 'new'} initialValues={initialValues} entityId={entityId} dictionaries={dictionaries} />
      ) : (
        <><CatalogEntityHeader kind="products" title="Товар" subtitle="Редактирование" /><CatalogRequestState error={errorMessage} onRetry={() => { void query.refetch(); }} /></>
      )}
    </section>
  );
}
